import React from "react";
import MapEmbed from "../components/MapEmbed";
import { CONTACT } from "../data";
import "../styles/Contact.css";
import { motion } from "framer-motion";

export default function Contact() {
  return (
    <section className="container page contact-page">
      {/* Header */}
      <motion.div
        className="contact-header"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="contact-title gradient-text">Contact Us</h2>
        <p className="contact-subtitle">
          Have questions or need help? Reach out by phone, social, or by filling
          out the form below.
        </p>
      </motion.div>

      {/* Grid */}
      <motion.div
        className="contact-grid"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ staggerChildren: 0.15 }}
      >
        {/* Left: Contact Form */}
        <motion.div
          className="contact-form"
          whileHover={{ scale: 1.01 }}
          whileTap={{ scale: 0.99 }}
        >
          <h4>Get in touch</h4>
          <p className="muted">
            Call or message us, or submit the form and we'll follow up.
          </p>

          {/* Updated Contact Info Section */}
          <div className="contact-info">
            {/* Phone numbers separated */}
            <div className="info-card">
              <span className="info-icon">📞</span>
              <div className="info-details">
                <span className="info-phone">{CONTACT.phone1}</span><br></br>
                <span className="info-phone">{CONTACT.phone2}</span>
              </div>
            </div>

            {/* Instagram clickable link */}
            <div className="info-card">
              <span className="info-icon">📷</span>
              <span className="info-instagram">
                <a
                  href="https://www.instagram.com/chennaicarcare"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="instagram-link"
                >
                  {CONTACT.instagram}
                </a>
              </span>
            </div>
          </div>

          {/* Contact Form */}
          <form
            className="contact-form-body"
            onSubmit={(e) => {
              e.preventDefault();
              alert("Message submitted (demo)");
            }}
          >
            <div className="form-row">
              <input placeholder="Your name" required />
            </div>
            <div className="form-row">
              <input placeholder="Email or phone" required />
            </div>
            <div className="form-row">
              <textarea placeholder="Message" rows={4} />
            </div>
            <motion.button
              className="btn"
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.9 }}
            >
              Send Message
            </motion.button>
          </form>
        </motion.div>

        {/* Right: Map & Address */}
        <motion.div
          className="contact-location"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h4>Location</h4>
          <div className="contact-map">
            <MapEmbed lat={12.910121} lng={80.19603} />
          </div>
          <div className="muted" style={{ marginTop: "0.8rem" }}>
            {CONTACT.address}
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
}
